import type { ReactNode } from "react";

/**
 * The studio's icons as inline SVG on a 24 grid, so every one sits on the same
 * centre whatever the font (the text glyphs they replace did not).
 */
function Svg({ children, size = 20 }: { children: ReactNode; size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
            {children}
        </svg>
    );
}

export const Icon = {
    pen: () => <Svg><path d="M4 20c2.5-.5 4-2 5-4l8.5-8.5a2.1 2.1 0 0 0-3-3L6 13c-2 1-3.5 2.5-4 5" /><path d="m13.5 6.5 4 4" /></Svg>,
    line: () => <Svg><path d="M5 19 19 5" /></Svg>,
    arrow: () => <Svg><path d="M5 19 19 5" /><path d="M10 5h9v9" /></Svg>,
    circle: () => <Svg><circle cx="12" cy="12" r="8" /></Svg>,
    box: () => <Svg><rect x="4" y="6" width="16" height="12" rx="2" /></Svg>,
    undo: () => <Svg><path d="M9 14 4 9l5-5" /><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" /></Svg>,
    redo: () => <Svg><path d="m15 14 5-5-5-5" /><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13" /></Svg>,
    clear: () => <Svg><path d="M4 7h16" /><path d="M10 11v6M14 11v6" /><path d="M6 7l1 13h10l1-13" /><path d="M9 7V4h6v3" /></Svg>,
    play: () => <Svg><path d="M7 4.5v15a1 1 0 0 0 1.5.9l12-7.5a1 1 0 0 0 0-1.8l-12-7.5A1 1 0 0 0 7 4.5Z" fill="currentColor" stroke="none" /></Svg>,
    pause: () => <Svg><rect x="6" y="4.5" width="4" height="15" rx="1" fill="currentColor" stroke="none" /><rect x="14" y="4.5" width="4" height="15" rx="1" fill="currentColor" stroke="none" /></Svg>,
    frameBack: () => <Svg><path d="m14 7-5 5 5 5" /></Svg>,
    frameForward: () => <Svg><path d="m10 7 5 5-5 5" /></Svg>,
    secondBack: () => <Svg><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /></Svg>,
    secondForward: () => <Svg><path d="M21 12a9 9 0 1 1-3-6.7L21 8" /><path d="M21 3v5h-5" /></Svg>,
    plus: () => <Svg><path d="M12 5v14M5 12h14" /></Svg>,
    mic: () => <Svg><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></Svg>,
    stop: () => <Svg><rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" stroke="none" /></Svg>,
    trash: () => <Svg size={18}><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></Svg>,
    note: () => <Svg size={14}><path d="M5 4h14v12l-4 4H5z" /><path d="M9 9h6M9 13h4" /></Svg>,
    shapes: () => <Svg size={14}><circle cx="8" cy="8" r="4" /><rect x="12" y="12" width="8" height="8" rx="1" /></Svg>,
    voice: () => <Svg size={14}><path d="M4 10v4M8 7v10M12 4v16M16 8v8M20 11v2" /></Svg>,
    sparkle: () => <Svg size={15}><path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z" fill="currentColor" stroke="none" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" fill="currentColor" stroke="none" /></Svg>,
    palette: () => <Svg><path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.5-.9 1.2-1.7-.4-1 .2-2.3 1.3-2.3H17a4 4 0 0 0 4-4c0-5.5-4-10-9-10Z" /><circle cx="7.5" cy="11" r="1" fill="currentColor" /><circle cx="10" cy="7" r="1" fill="currentColor" /><circle cx="14.5" cy="7" r="1" fill="currentColor" /></Svg>,
};
